<template>
  <div>
    <!-- 기본정보 (숨김 - 데이터 유지용) -->
    <field-select-module v-show="false" v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <div>
      <h5 class="mb-4"><i class="dot"></i> 연도별 인센티브 Cap</h5>
      <div class="writeGridContainer">
        <div>
          <div>연도</div>
          <p v-if="isPrint" class="print-input">{{ form.연도 }}</p>
          <ml-input v-else type="number" v-model="form.연도" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 사업장별 Cap 점수</h5>
      <table class="cap-table">
        <colgroup>
          <col />
          <col />
          <col v-if="!board.readonly && !isPrint" style="width: 60px" />
        </colgroup>
        <thead>
          <tr>
            <th>사업장명</th>
            <th>Cap 점수(점)</th>
            <th v-if="!board.readonly && !isPrint">
              <vs-button size="small" icon-pack="feather" icon="icon-plus" @click="addRow" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in form.capList" :key="`cap-row-${rowIndex}`">
            <td>
              <p v-if="isPrint" class="print-input">{{ row.사업장명 }}</p>
              <ml-input v-else v-model="row.사업장명" :readonly="board.readonly" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ row.점수 }}</p>
              <ml-input v-else type="number" v-model="row.점수" :readonly="board.readonly" />
            </td>
            <td v-if="!board.readonly && !isPrint" class="text-center">
              <vs-button size="small" color="danger" type="border" icon-pack="feather" icon="icon-minus" @click="delRow(rowIndex)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";

export default {
  components: {
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        연도: new Date().getFullYear(),
        capList: [
          { 사업장명: "인천공장", 점수: "" },
          { 사업장명: "포항공장", 점수: "" },
          { 사업장명: "당진공장", 점수: "" },
        ],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key] !== undefined && value[key] !== null) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    validate() {
      if (!this.form.연도) {
        return "연도를 입력해주세요.";
      }
    },
    addRow() {
      this.form.capList.push({ 사업장명: "", 점수: "" });
    },
    delRow(index) {
      this.form.capList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.cap-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 8px;
  }

  th {
    background: #f7f8fa;
    font-weight: 600;
  }
}
</style>
